import { render, staticRenderFns } from "./ShiftCalendar.vue?vue&type=template&id=632fdb80&"
import script from "./ShiftCalendar.vue?vue&type=script&lang=js&"
export * from "./ShiftCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ShiftCalendar.vue?vue&type=style&index=0&id=632fdb80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports